// extracted by mini-css-extract-plugin
module.exports = {"container":"im-z","heading":"jm-z","links":"km-z","linkBtn":"lm-z","disabled":"mm-z","linkUppercaseBold":"nm-z","copy":"om-z","subCopy":"pm-z"};